// getMinRequiredUserLevelByVipBenefitLevel.js
'use strict';

/**
 * Gets the minimum required user level for a given VIP benefit level.
 *
 * This selector resolves the lower bound of the user level range
 * for a given VIP benefit level, as defined in the
 * USER_LEVEL_BENEFIT_THRESHOLD remote config.
 *
 * Example:
 *   USER_LEVEL_BENEFIT_THRESHOLD = "1:1~10 2:11~20 3:21~30 4:31~40 ..."
 *   getMinRequiredUserLevelByVipBenefitLevel({
 *     thresholdList,
 *     vipBenefitLevel: 3,
 *   });
 *   // => 21
 *
 * Note:
 * - User level ranges from 1 to 100.
 * - VIP benefit level (tier) ranges from 1 to 10 and groups user levels
 *   based on the remote config definition.
 *
 * @param {Object} params
 * @param {Array<{ min: number, max: number, level: number }>} params.thresholdList
 *   Parsed user level threshold list, where each item defines a VIP benefit level
 *   and its corresponding user level range.
 * @param {number} params.vipBenefitLevel
 *   VIP benefit level (tier) used to resolve the user level range.
 * @return {number | undefined}
 *   The minimum required user level for the given VIP benefit level.
 */
const getMinRequiredUserLevelByVipBenefitLevel = ({
  thresholdList,
  vipBenefitLevel,
}) => {
  const { min: minRequiredUserLevel } =
    thresholdList.find(item => item.level === vipBenefitLevel) ?? {};
  return minRequiredUserLevel;
};

export default getMinRequiredUserLevelByVipBenefitLevel;
